import { cn } from "../lib/cn";

export type StatusType = "online" | "offline" | "warning" | "error";

export interface StatusIndicatorProps {
  status: StatusType;
  label?: string;
  className?: string;
}

const dotColors: Record<StatusType, string> = {
  online: "bg-green-dark",
  offline: "bg-[#4a4a4a]",
  warning: "bg-amber",
  error: "bg-error",
};

export function StatusIndicator({
  status,
  label,
  className,
}: StatusIndicatorProps) {
  return (
    <div className={cn("inline-flex items-center gap-2", className)}>
      <span
        className={cn("h-1.5 w-1.5 rounded-full", dotColors[status])}
        aria-hidden="true"
      />
      {label && (
        <span className="text-text-dim font-mono text-[10px] uppercase">
          {label}
        </span>
      )}
    </div>
  );
}
